export enum AlertType {
  Success = 'success',
  Error = 'error',
  Warning = 'warning'
}
